import { tv } from 'tailwind-variants';

const Paper = tv({
  base: 'rounded-md xs:w-full lg:w-[750px] py-2 min-h-6 bg-color-lightest shadow-level-1 relative',
});

const Lines = tv({
  base: 'border-b-[2px] border-brand-color-primary-lighter h-[30px]',
});

const LineContent = tv({
  base: 'xs:hidden md:flex flex-row items-center justify-between h-full w-[70px] border-r-[3px] border-brand-color-secondary-pure px-2',
});

const ContentWrapper = tv({
  base: 'relative h-full md:pl-[70px]',
});

const PaperContent = tv({
  base: 'inline-flex h-full px-3 py-1 w-full leading-[30px] border-none overflow-hidden justify-center items-center resize-none text-left bg-transparent font-notoSans text-md font-normal',
});

export { PaperContent, ContentWrapper, LineContent, Lines, Paper };
